import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { NgbCollapseModule, NgbDatepickerModule, NgbTimepickerModule, NgbDropdownModule, NgbAccordionModule, NgbPagination, NgbPaginationModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';

import { DashboardSharedComponent } from './dashboard.shared.component';
import { UIModule } from '../ui/ui.module';
import { NgxMaskModule } from 'ngx-mask';

import { NgApexchartsModule } from 'ng-apexcharts';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxSpinnerModule } from 'ngx-spinner';

import { TreeviewModule } from 'ngx-treeview';
import { DropdownTreeviewSelectModule } from '../helper/dropdownTreeviewSelect/dropdown-treeview-select.module';


@NgModule({
  declarations: [DashboardSharedComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgbCollapseModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
    NgbDropdownModule,
    UIModule,
    NgApexchartsModule,
    NgSelectModule,
    NgxSpinnerModule,
    NgxMaskModule.forRoot(),
    TreeviewModule.forRoot(),
    DropdownTreeviewSelectModule,
    NgbCollapseModule,
    NgbPaginationModule,
    NgbTypeaheadModule,
  ],
  exports: [DashboardSharedComponent]
})
export class DashboardSharedModule { }
